import React from 'react';
import './Hero.css';
import { useTranslation } from '../../i18n/TranslationContext';

const Hero: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <section id="accueil" className="hero">
      <div className="container">
        <div className="hero-content glass-panel">
          <h1>{t.hero.title}</h1>
          <h2>{t.hero.services}</h2>
          <p className="hero-subtitle">
            {t.hero.experience}
          </p>
          <a href="#contact" className="btn">{t.hero.cta}</a>
        </div>
      </div>
    </section>
  );
};

export default Hero;